import { useFormikContext } from 'formik'
import get from 'lodash.get'
import { IVenueFormValues } from 'FormPage/FormPage'
import { Select, ISelectProps } from '@nextretreat/ui-components/dist/Select'

export const SelectFormik = ({
  invalid,
  name = '',
  ...passingProps
}: ISelectProps) => {
  const { errors, touched } = useFormikContext<IVenueFormValues>()

  return (
    <Select
      {...passingProps}
      invalid={invalid || !!(get(errors, name) && get(touched, name))}
    />
  )
}
